// Job Card Component

import React from "react";
import { motion } from "framer-motion";
import { MapPin, Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Job } from "../../data/jobsData";
export interface JobCardProps {
  job: Job;
  getCategoryStyles: (color: Job["categoryColor"]) => string;
}

export const JobCard: React.FC<JobCardProps> = ({ job, getCategoryStyles }) => {
  return (
    <div className="group h-full">
      <div className="h-full p-6 lg:p-8 rounded-2xl bg-white border border-gray-100 shadow-sm hover:shadow-xl hover:border-[#8B52FF]/20 transition-all duration-300 flex flex-col">
        {/* Header */}
        <div className="flex items-start justify-between mb-4">
          <span
            className={`px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide ${getCategoryStyles(job.categoryColor)}`}
          >
            {job.category}
          </span>
          <span className="text-lg font-bold text-gray-900">
            {job.payRange}
          </span>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-[#8B52FF] transition-colors">
          {job.title}
        </h3>

        {/* Meta */}
        <div className="flex items-center gap-4 mb-4 text-sm text-gray-500">
          <span className="flex items-center gap-1.5">
            <MapPin className="w-4 h-4 text-[#8B52FF]" />
            {job.locationType}
          </span>
          <span className="flex items-center gap-1.5">
            <Clock className="w-4 h-4 text-[#E05A6A]" />
            {job.schedule}
          </span>
        </div>

        {/* Description */}
        <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-grow line-clamp-3">
          {job.description}
        </p>

        {/* Skills */}
        <div className="flex flex-wrap gap-2 mb-6">
          {job.skills.slice(0, 3).map((skill, index) => (
            <span
              key={index}
              className="px-3 py-1.5 rounded-lg bg-gray-50 text-xs font-medium text-gray-600 border border-gray-100"
            >
              {skill}
            </span>
          ))}
          {job.skills.length > 3 && (
            <span className="px-3 py-1.5 rounded-lg bg-gray-50 text-xs font-medium text-gray-400 border border-gray-100">
              +{job.skills.length - 3} more
            </span>
          )}
        </div>

        {/* CTA */}
        <Link to={`/careers/${job.id}`} className="mt-auto">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="w-full py-3 px-6 rounded-xl bg-gradient-to-r from-[#8B52FF] to-[#E05A6A] text-white font-semibold shadow-lg shadow-[#8B52FF]/20 hover:shadow-xl hover:shadow-[#8B52FF]/30 transition-all duration-300 flex items-center justify-center gap-2 group/btn"
          >
            View Details
            <ArrowRight className="w-4 h-4 group-hover/btn:translate-x-1 transition-transform" />
          </motion.button>
        </Link>
      </div>
    </div>
  );
};
